// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__22kTl","footer":"ModalInfo_footer__3Z-XF"};